export var AppModulePreferedLayout;
(function (AppModulePreferedLayout) {
    AppModulePreferedLayout[AppModulePreferedLayout["None"] = 0] = "None";
    AppModulePreferedLayout[AppModulePreferedLayout["Default"] = 1] = "Default";
    AppModulePreferedLayout[AppModulePreferedLayout["Minimal"] = 2] = "Minimal";
})(AppModulePreferedLayout || (AppModulePreferedLayout = {}));
